export default __webpack_public_path__ + "static/media/assign-userl.35cd415e.svg";